import { gql } from '__generated__';

export default gql(`
  mutation DeleteMailPermission($id: ID!) {
    deleteMailPermission(id: $id)
  }
`);
